import { useFetch, usePost } from '../utils/queries';

const AUTH_BASE = 'auth';

interface LoginVariables {
  email: string;
  password: string;
}

interface LoginResponse {
  token: string;
  user: { id: string; email: string };
}

interface RefreshResponse {
  accessToken: string;
}

interface RegisterVariables {
  email: string;
  password: string;
}

interface RegisterResponse {
  token: string;
}

function useGetUser(options = {}) {
  return useFetch<{ id: string; email: string }>(
    `${AUTH_BASE}/user`,
    undefined,
    {
      options: {
        ...options
      }
    }
  );
}

function useLogin(options = {}) {
  return usePost<LoginResponse, unknown, LoginVariables>(
    `${AUTH_BASE}/login`,
    undefined,
    {
      options: {
        invalidateAll: true,
        ...options
      }
    }
  );
}

function useRefresh(options = {}) {
  return usePost<RefreshResponse, unknown, unknown>(
    `${AUTH_BASE}/refresh`,
    undefined,
    {
      options: {
        invalidateAll: true,
        ...options
      }
    }
  );
}

function useRegister(options = {}) {
  return usePost<RegisterResponse, unknown, RegisterVariables>(
    `${AUTH_BASE}/register`,
    undefined,
    {
      options: {
        invalidateAll: true,
        ...options
      }
    }
  );
}

function useChangePassword(options = {}) {
  return usePost<RegisterResponse, unknown, RegisterVariables>(
    `${AUTH_BASE}/change-password`,
    undefined,
    {
      options: {
        invalidateAll: true,
        ...options
      }
    }
  );
}

function useResetPassword(options = {}) {
  return usePost<RegisterResponse, unknown, RegisterVariables>(
    `${AUTH_BASE}/reset-password`,
    undefined,
    {
      options: {
        invalidateAll: true,
        ...options
      }
    }
  );
}

export { useLogin, useRefresh, useGetUser, useRegister, useChangePassword, useResetPassword };
